import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const CitiesWeServeSection = () => {
  const cities = [
    { name: 'Toronto', link: '/international-courier-toronto' },
    { name: 'Brampton', link: '/international-shipping-brampton' },
    { name: 'Mississauga', link: '/international-shipping-mississauga' },
    { name: 'Surrey', link: '/international-shipping-surrey' },
    { name: 'Vancouver', link: '/international-shipping-vancouver' },
    { name: 'Nova Scotia', link: '/international-shipping-nova-scotia' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Cities We Serve
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Shippzy provides international shipping services across Canada. We offer convenient pickup, 
            drop-off locations, and door-to-door delivery from major cities nationwide.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {cities.map((city, index) => (
            <a 
              key={index} 
              href={city.link}
              className="block"
            >
              <Card 
                className="text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer border-2 hover:border-red-500 h-full"
              >
                <CardContent className="pt-8 pb-8">
                  <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <MapPin className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{city.name}</h3>
                  <div className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-semibold mt-3 group">
                    View Services
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>

        <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-8 rounded-xl text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Serving All Across Canada
          </h3>
          <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto">
            Don't see your city listed? We serve many more locations across Canada including Calgary, 
            Edmonton, Montreal, Ottawa, Halifax, Winnipeg, and more. Contact us for pickup and delivery 
            options in your area.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Button 
              className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white px-8 py-3"
              onClick={() => window.location.href = '#contact'}
            >
              Contact Us
            </Button>
            <Button 
              variant="outline"
              className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-3"
              onClick={() => window.location.href = '/drop-off-locations'}
            >
              Find Drop-Off Locations
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CitiesWeServeSection;
